import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginLayoutComponent } from './login-layout/login-layout.component';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { PartialsModule } from './shared/partials/partials.module';
import { WaitPageComponent } from './pages/wait-page/wait-page.component';
import { VerifyEmailComponent } from './pages/verify-email/verify-email.component';
import { MfaChallengeComponent } from './pages/mfa-challenge/mfa-challenge.component';
import { EnrollMfaComponent } from './pages/enroll-mfa/enroll-mfa.component';
import { AuthActionComponent } from './pages/auth-action/auth-action.component';

@NgModule({
  declarations: [
    LoginLayoutComponent,
    LoginComponent,
    LogoutComponent,
    PasswordResetComponent,
    WaitPageComponent,
    VerifyEmailComponent,
    MfaChallengeComponent,
    EnrollMfaComponent,
    AuthActionComponent,
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    PartialsModule,
  ],
  providers: [],
})
export class LoginModule {}
